import i18nInstance from 'i18n/i18nInstance'
import { z } from 'zod'
import { createValidator } from '@mc/form-utils'

const tf = i18nInstance.getFixedT(null, '@mc/next')

export const joinWaitListSchema = z.object({
  emailInput: z
    .string({
      required_error: tf(
        'sessions.campHeroCTAs.joinWaitListForm.emailRequired',
      ),
    })
    .min(1, tf('sessions.campHeroCTAs.joinWaitListForm.emailRequired'))
    .email(tf('sessions.campHeroCTAs.joinWaitListForm.emailInvalid')),
})

export const validateJoinWaitListForm = createValidator(joinWaitListSchema)
